// extracted by mini-css-extract-plugin
export default {"container":"WagonsReportSummaryTooltip_container__4GH4B"};